/**
 * SignalR messages hub URL for real-time message notifications.
 * Must be HTTP/HTTPS (not ws/wss): the client uses it for the negotiate request (Fetch API),
 * then SignalR upgrades to WebSocket for the connection.
 *
 * In the browser we use the current origin + /hubs/messages so the request is same-origin:
 * the dev server (Vite/webpack) can proxy /hubs to the backend, avoiding CORS and ERR_FAILED.
 * Use REACT_APP_WS_URL if set (ws/wss converted to http/https); otherwise same-origin in browser,
 * or derive from REACT_APP_API_URL when not in browser (e.g. SSR/tests).
 */
export function getMessagesHubUrl() {
    let explicit = process.env.REACT_APP_WS_URL;
    if (explicit) {
        if (explicit.endsWith("/hubs") && !explicit.endsWith("/hubs/messages")) {
            explicit = `${explicit}/messages`;
        }
        // SignalR negotiate uses HTTP; convert ws/wss to http/https
        if (explicit.startsWith("ws://")) {
            return "http://" + explicit.slice(5);
        }
        if (explicit.startsWith("wss://")) {
            return "https://" + explicit.slice(6);
        }
        return explicit;
    }
    if (typeof window !== "undefined") {
        return `${window.location.origin}/hubs/messages`;
    }
    const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5289/api";
    try {
        const url = new URL(apiUrl);
        const base = `${url.protocol}//${url.host}`;
        return `${base}/hubs/messages`;
    }
    catch {
        return "http://localhost:5289/hubs/messages";
    }
}
/**
 * SignalR notifications hub URL for real-time general notifications.
 * Same env/proxy behaviour as getMessagesHubUrl; path is /hubs/notifications.
 */
export function getNotificationsHubUrl() {
    let explicit = process.env.REACT_APP_WS_URL;
    if (explicit) {
        if (explicit.endsWith("/hubs") && !explicit.endsWith("/hubs/notifications")) {
            explicit = `${explicit}/notifications`;
        }
        else if (explicit.endsWith("/hubs/messages")) {
            explicit = explicit.replace("/messages", "/notifications");
        }
        if (explicit.startsWith("ws://")) {
            return "http://" + explicit.slice(5);
        }
        if (explicit.startsWith("wss://")) {
            return "https://" + explicit.slice(6);
        }
        return explicit;
    }
    if (typeof window !== "undefined") {
        return `${window.location.origin}/hubs/notifications`;
    }
    const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5289/api";
    try {
        const url = new URL(apiUrl);
        const base = `${url.protocol}//${url.host}`;
        return `${base}/hubs/notifications`;
    }
    catch {
        return "http://localhost:5289/hubs/notifications";
    }
}
